
import { defineComponent, ref } from "vue";
import BaseModal from "@/components/modals/BaseModal.vue";
import { useStore } from "@/store";

export default defineComponent({
  props: {
    callback: {
      type: Function,
      default: undefined,
    },
  },
  components: {
    BaseModal,
  },
  setup(props) {
    const store = useStore();
    const folderId = ref(store.state.folderId);
    const folderUrl = ref("");
    const folderUrlValue = ref("");
    const openHandler = () => {
      folderId.value = store.state.folderId;
      folderUrl.value = folderId.value
        ? `https://drive.google.com/drive/folders/${folderId.value}`
        : "";
      folderUrlValue.value = "";
    };
    const confirmHandler = () => {
      // Google Drive url has two formats：
      // 1. https://drive.google.com/drive/folders/{folderId}
      // 2. https://drive.google.com/folderview?id={folderId}

      const url = new URL(folderUrlValue.value);
      folderId.value =
        url.searchParams.get("id") || url.pathname.split("/").pop();
      folderUrl.value = folderUrlValue.value;
      store.commit("setFolder", folderId.value);
      props.callback && props.callback();
    };

    return {
      props,
      folderId,
      folderUrl,
      folderUrlValue,
      openHandler,
      confirmHandler,
    };
  },
});
